import { waitFor } from '..';

export const timeoutAfter = (ms: number) => <T>(p: T | Promise<T>) => Promise.race([p, waitFor(ms)]);
